import { CheckmarkCircleIcon } from '@datacamp/waffles-icons';
import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const thanksStyle = {
  alignItems: 'center',
  display: 'flex',
  flexBasis: '100%',
  justifyContent: 'center'
};
const ThanksForRating = _ref => {
  let {
    ratedMessage
  } = _ref;
  return ___EmotionJSX("div", {
    style: thanksStyle
  }, ___EmotionJSX(CheckmarkCircleIcon, {
    className: "dc-u-mr-4"
  }), ___EmotionJSX("p", {
    className: "dc-u-m-4"
  }, ratedMessage));
};
export default ThanksForRating;